import { Content, TDocumentDefinitions } from "pdfmake/interfaces";
import CompanyLogoForm from "react-lib/apps/HISV3/common/CompanyLogoForm";

import CONFIG from "config/config";

const FormPaySlip = async (props: any): Promise<TDocumentDefinitions> => {
  var origin = window?.location?.origin;

  const MONTH_OPTION = [
    { value: 1, key: 1, text: "ม.ค.", number: "01" },
    { value: 2, key: 2, text: "ก.พ.", number: "02" },
    { value: 3, key: 3, text: "มี.ค.", number: "03" },
    { value: 4, key: 4, text: "เม.ย.", number: "04" },
    { value: 5, key: 5, text: "พ.ค.", number: "05" },
    { value: 6, key: 6, text: "มิ.ย.", number: "06" },
    { value: 7, key: 7, text: "ก.ค.", number: "07" },
    { value: 8, key: 8, text: "ส.ค.", number: "08" },
    { value: 9, key: 9, text: "ก.ย.", number: "09" },
    { value: 10, key: 10, text: "ต.ค.", number: "10" },
    { value: 11, key: 11, text: "พ.ย.", number: "11" },
    { value: 12, key: 12, text: "ธ.ค.", number: "12" },
  ];

  const formatDate = (date?: string | null, keepYear: boolean = true): string => {
    if (!date) return "-";
    const parts = date.split('/');
    if (parts.length !== 3) return date;

    const [day, month, year] = parts;
    const monthObj = MONTH_OPTION.find(m => m.number === month);
    if (!monthObj) return date;

    return keepYear
      ? `${parseInt(day)} ${monthObj.text} ${year}`
      : `${parseInt(day)} ${monthObj.text}`;
  };

  const companyLogoForm = await CompanyLogoForm({
      font: "THSarabunNew",
      height: 100,
      form: "",
    });
  
  const { images } = companyLogoForm;

  const header = (): Content => {
    return {
      stack: [
        {
          columns: [
            {
              image: 'logo',
              width: 120
            },
            {
              text: 'สลิปเงินเดือน / Pay Slip',
              alignment: 'center',
              bold: true,
              fontSize: 18,
              margin: [0, 2.5, 0, 0]
            }
          ],
          columnGap: -130
        },
        {
          columns: [
            {
              width: 360,
              stack: [
                {
                  text: [
                    { text: 'เลขประจำตัวผู้เสียภาษี/ Tax ID:     ', style: ['tightText', 'headerData'], lineHeight: 0.8 },
                    { text: props.tax_id, style: ['tightText', 'headerData'], lineHeight: 0.8 }
                  ]
                },
                {
                  text: [
                    { text: 'ชื่อนามสกุล (รหัส)/ Emp. name (Code): ', style: ['tightText', 'headerData'], lineHeight: 0.8 },
                    { text: `${props.employee_full_name} (${props.employee_code})`, style: ['tightText', 'headerData'], lineHeight: 0.8 }
                  ]
                },
                {
                  text: [
                    { text: 'แผนก/ Division:       ', style: ['tightText', 'headerData'], lineHeight: 0.8 },
                    { text: props.employee_department, style: ['tightText', 'headerData'], lineHeight: 0.8 }
                  ]
                },
                {
                  text: [
                    { text: 'ตำแหน่ง/ Position:   ', style: ['tightText', 'headerData'], lineHeight: 0.8 },
                    { text: props.employee_position, style: ['tightText', 'headerData'], lineHeight: 0.8 }
                  ]
                }
              ]
            },
            {
              table: {
                widths: ['auto', '*'],
                body: [
                  [
                    { text: 'รอบเงินเดือน/ Payroll Period:', style: ['tightText', 'headerData'] },
                    { text: `${formatDate(props.cycle_date_start, false)} - ${formatDate(props.cycle_date_end)}`, style: ['tightText', 'headerData'] }
                  ],
                  [
                    { text: 'วันที่ชำระ/ Payment Date:', style: ['tightText', 'headerData'] },
                    { text: formatDate(props.payment_date) || formatDate(props.due_date), style: ['tightText', 'headerData'] }
                  ],
                  [
                    { text: 'เลขที่บัญชี/ Bank Account:', style: ['tightText', 'headerData'] },
                    { text: props.bank_account_no, style: ['tightText', 'headerData'] }
                  ]
                ]
              },
              layout: 'noBorders'
            }
          ],
          columnGap: 0,
          margin: [0, 0, 0, 0]
        }
      ],
      margin: [20, 0, 0, 0]
    };
  };

  const detailTable = (): Content => {
    const grayBg = '#f0f0f0';
    const payrollRevenueItems = props.payroll_items?.filter((item: { type: string; }) => item.type === 'revenue') || [];
    const payrollDeductItems = props.payroll_items?.filter((item: { type: string; }) => item.type === 'deduct') || [];

    const shiftAllowance = payrollRevenueItems.find((item: { code: string }) => item.code === 'R001') || null;
    let otherRevenue = payrollRevenueItems
      .filter((item: { code: string; }) => item.code !== 'R001')
      .reduce((sum: any, item: { amount: any; }) => sum + (item.amount || 0), 0);

    otherRevenue += parseFloat(props.bonus.replace(/,/g, '')) || 0;
    otherRevenue += parseFloat(props.doctor_fee.replace(/,/g, '')) || 0;

    const studentLoadFund = payrollDeductItems.find((item: { code: string }) => item.code === 'D001') || null;
    const otherDeduct = payrollDeductItems
      .filter((item: { code: string; }) => item.code !== 'D001')
      .reduce((sum: any, item: { amount: any; }) => sum + (item.amount || 0), 0);

    const revenueData = [
      [
        { text: 'เงินเดือน/ค่าจ้าง\nSalary/Wage', style: 'dataTableHeader' },
        { text: props.salary, style: 'dataTableData' }
      ],
      [
        { text: 'ค่าล่วงเวลา\nOvertime', style: 'dataTableHeader' },
        { text: props.overtime, style: 'dataTableData' }
      ],
      [
        { text: 'ค่าตำแหน่ง\nPosition', style: 'dataTableHeader' },
        { text: props.position_pay, style: 'dataTableData' }
      ],
      [
        { text: 'ค่าเวร/ค่ากะ\nShift Allowance', style: 'dataTableHeader' },
        { text: (shiftAllowance?.amount ?? 0).toFixed(2), style: 'dataTableData' }
      ],
      [
        { text: 'ค่าใบอนุญาตประกอบวิชาชีพ\nLicense', style: 'dataTableHeader' },
        { text: props.license_allowance, style: 'dataTableData' }
      ],
      [
        { text: 'ค่าภาษา\nLanguage', style: 'dataTableHeader' },
        { text: props.language_pay, style: 'dataTableData' }
      ],
      [
        { text: 'ค่าประสบการณ์\nSkill', style: 'dataTableHeader' },
        { text: props.skill_pay, style: 'dataTableData' }
      ],
      [
        { text: 'เงินได้อื่นๆ\nOthers', style: 'dataTableHeader' },
        { text: otherRevenue.toFixed(2), style: 'dataTableData' }
      ]
    ];

    const deductData = [
      [
        { text: 'ประกันสังคม\nSocial Security Fund', style: 'dataTableHeader' },
        { text: props.social_security_fund, style: 'dataTableData' }
      ],
      [
        { text: 'ภาษีหัก ณ ที่จ่าย\nWithholding tax', style: 'dataTableHeader' },
        { text: props.with_holding_tax, style: 'dataTableData' }
      ],
      [
        { text: 'เงินกู้ยืม กยศ./กรอ.\nStudent Loan Fund', style: 'dataTableHeader' },
        { text: (studentLoadFund?.amount ?? 0).toFixed(2), style: 'dataTableData' }
      ],
      [
        { text: 'กองทุนสำรองเลี้ยงชีพ\nProvident Fund', style: 'dataTableHeader' },
        { text: props.providence_fund, style: 'dataTableData' }
      ],
      [
        { text: 'ขาด/ลา/มาสาย\nAbsent/Leave/Late', style: 'dataTableHeader' },
        { text: props.absence, style: 'dataTableData' }
      ],
      [
        { text: 'รายการหักอื่นๆ\nOthers', style: 'dataTableHeader' },
        { text: otherDeduct.toFixed(2), style: 'dataTableData' }
      ]
    ];

    const summaryData = [
      [
        { text: 'เงินได้สะสม\nYTD earning', style: 'dataTableHeader' },
        { text: props.ytd_earning, style: 'dataTableData' }
      ],
      [
        { text: 'ภาษีหัก ณ ที่จ่ายสะสม\nYTD Withholding tax', style: 'dataTableHeader' },
        { text: props.ytd_with_holding_tax, style: 'dataTableData' }
      ],
      [
        { text: 'เงินประกันสังคมสะสม\nAccumulated SSF', style: 'dataTableHeader' },
        { text: props.accumulated_ssf, style: 'dataTableData' }
      ],
      [
        { text: 'กองทุนสำรองเลี้ยงชีพสะสม\nAccumulated Provident Fund', style: 'dataTableHeader' },
        { text: props.accumulated_provident_fund, style: 'dataTableData' }
      ]
    ];

    const totalData = [
      [
        { text: 'รวมเงินได้\nTotal earnings', style: 'dataTableHeader', marginLeft: 4 },
        { text: props.total_revenue, style: 'dataTableData', marginRight: 4 }
      ],
      [
        { text: 'รวมรายการหัก\nTotal deductions', style: 'dataTableHeader', marginLeft: 4, marginBottom: -15 },
        { text: props.total_deduct, style: 'dataTableData', marginRight: 4, marginBottom: -15 }
      ],
      [
        { text: 'เงินได้สุทธิ\nNet pay', style: 'dataTableHeader', fillColor: grayBg, marginLeft: 4, marginTop: 5 },
        { text: props.net_salary, style: 'dataTableData', fillColor: grayBg, bold: true, marginRight: 4, marginTop: 5 }
      ]
    ];

    const createNestedTable = (data: any, isTotal: boolean = false): Content => ({
      table: {
        widths: ['*', 'auto'],
        heights: isTotal ? [25, 25, 35] : 25,
        body: data
      },
      layout: 'noBorders',
      margin: isTotal ? [-4, 0, -4, 0] : [0, 0, 0, 0]
    });

    return {
      table: {
        widths: ['*', '*', '*'],
        body: [
          [
            { text: 'รายได้\nEarnings', style: 'tableHeader', fillColor: grayBg, alignment: 'center', valign: 'middle' },
            { text: 'รายการหัก\nDeductions', style: 'tableHeader', fillColor: grayBg, alignment: 'center', valign: 'middle' },
            { text: `ปี\n${props.current_year}`, style: 'tableHeader', fillColor: grayBg, alignment: 'center', valign: 'middle' }
          ],
          [
            { rowSpan: 2, margin: [0, 2.5, 0, 2.5], stack: [createNestedTable(revenueData)] },
            { rowSpan: 2, margin: [0, 2.5, 0, 2.5], stack: [createNestedTable(deductData)] },
            { margin: [0, 2.5, 0, 2.5], stack: [createNestedTable(summaryData)] }
          ],
          [
            null,
            null,
            { margin: [0, 2.5, 0, 2.5], stack: [createNestedTable(totalData, true)] }
          ]
        ]
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
        hLineColor: () => '#aaaaaa',
        vLineColor: () => '#aaaaaa',
        fillColor: () => null
      },
      margin: [20, 0, 20, 0]
    };
  };

  return {
    pageSize: "A5",
    pageOrientation: 'landscape',
    pageMargins: [0, 90, 0, 60],
    info: {
      title: props.file_name,
      },
    header: header(),
    content: [
      detailTable()
    ],
    defaultStyle: {
      font: 'THSarabunNew',
    },
    styles: {
      tightText: {
        margin: [0, -3.5, 0, -3.5]
      },
      headerHeader: {
        bold: true,
        fontSize: 12,
      },
      headerData: {
        fontSize: 12,
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        alignment: 'center',
        lineHeight: 0.6,
        marginBottom: 2.5
      },
      tableData: {
        fontSize: 12,
      },
      dataTableHeader: {
        fontSize: 12,
        lineHeight: 0.6,
      },
      dataTableData: {
        fontSize: 12,
        alignment: "right",
      },
      footerSignature: {
        bold: true,
        fontSize: 12
      },
    },
    footer: function (currentPage: number, pageCount: number) {
      return {
        margin: [20, 10, 20, 10],
        columns: [
          {
            width: 372.5,
            stack: [
              { text: `หมายเหตุ: ${props.remark ? props.remark : ''}`, margin: [0, 0, 0, -5], alignment: 'left' },
              { text: 'Remarks', alignment: 'left' }
            ]
          },
          {
            width: '*',
            stack: [
              { text: 'ลายเซ็นผู้จ่ายเงิน_________________________', margin: [0, 0, 0, -5], alignment: 'left' },
              { text: "Employer's Signature", alignment: 'left' }
            ]
          }
        ]
      };
    },
    images: {
      background: origin + "/static/images/logoform/SAPIENS/HeaderSapiensForm.png",
      ...images
    },
    userPassword: props.passwordProtection 
      ? (props.employee_citizen_no !== '' 
          ? props.employee_citizen_no 
          : (props.employee_passport_no !== '' ? props.employee_passport_no : ''))
      : '',
    ownerPassword: props.passwordProtection 
      ? (props.employee_passport_no !== '' 
          ? props.employee_passport_no 
          : (props.employee_citizen_no !== '' ? props.employee_citizen_no : ''))
      : '',
    permissions: {
      printing: 'highResolution',
      modifying: true,
      copying: true,
      annotating: true,
      fillingForms: true,
      contentAccessibility: true,
      documentAssembly: true
    }
  };
};

export default FormPaySlip;
